/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PalReauthSubmissionStatus } from './PalReauthSubmissionStatus';
import {
    PalReauthSubmissionStatusFromJSON,
    PalReauthSubmissionStatusFromJSONTyped,
    PalReauthSubmissionStatusToJSON,
    PalReauthSubmissionStatusToJSONTyped,
} from './PalReauthSubmissionStatus';
import type { PalReauthSubmissionTimingState } from './PalReauthSubmissionTimingState';
import {
    PalReauthSubmissionTimingStateFromJSON,
    PalReauthSubmissionTimingStateFromJSONTyped,
    PalReauthSubmissionTimingStateToJSON,
    PalReauthSubmissionTimingStateToJSONTyped,
} from './PalReauthSubmissionTimingState';
import type { PalReauthCaseManager } from './PalReauthCaseManager';
import {
    PalReauthCaseManagerFromJSON,
    PalReauthCaseManagerFromJSONTyped,
    PalReauthCaseManagerToJSON,
    PalReauthCaseManagerToJSONTyped,
} from './PalReauthCaseManager';
import type { PalAuthSubmissionStatusUpdatedByUser } from './PalAuthSubmissionStatusUpdatedByUser';
import {
    PalAuthSubmissionStatusUpdatedByUserFromJSON,
    PalAuthSubmissionStatusUpdatedByUserFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserToJSON,
    PalAuthSubmissionStatusUpdatedByUserToJSONTyped,
} from './PalAuthSubmissionStatusUpdatedByUser';
import type { PalReauthSubmissionStatusInfo } from './PalReauthSubmissionStatusInfo';
import {
    PalReauthSubmissionStatusInfoFromJSON,
    PalReauthSubmissionStatusInfoFromJSONTyped,
    PalReauthSubmissionStatusInfoToJSON,
    PalReauthSubmissionStatusInfoToJSONTyped,
} from './PalReauthSubmissionStatusInfo';

/**
 * 
 * @export
 * @interface PalReauthSubmission
 */
export interface PalReauthSubmission {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    pal_submission_id: string;
    /**
     * 
     */
    status: PalReauthSubmissionStatus;
    /**
     * 
     */
    status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     */
    previous_status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     */
    external_id?: string | null;
    /**
     * 
     */
    next_review_date?: string | null;
    /**
     * 
     */
    timing_state: PalReauthSubmissionTimingState;
    /**
     * 
     */
    can_revert_status: boolean;
    /**
     * 
     */
    case_manager?: PalReauthCaseManager;
    /**
     * 
     */
    status_updated_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     */
    submitted_at?: Date | null;
    /**
     * 
     */
    submitted_by_user_id?: string | null;
    /**
     * 
     */
    submitted_by_user?: PalAuthSubmissionStatusUpdatedByUser;
    /**
     * 
     */
    date_created: Date;
    /**
     * 
     */
    submission_mode?: string;
    /**
     * 1-based re-auth cycle number for the lead (oldest cycle is 1)
     */
    cycle_number?: number;
    /**
     * Deprecated; kept for clients deployed before the per-source flags. True when `pal_reauths` and `pcc_data_relay_enabled` are both on for the submission's facility, which is whenever the Re-Auth tab is shown, so the document collection wizard is always rendered.
     * @deprecated
     */
    is_document_collection_enabled?: boolean;
    /**
     * True when document collection is enabled, the Net Health document retrieval screener setting is on for the submission's facility, and that facility has a PCC consumer site id. Step 1 shows the document window picker and Pull Documents only when this is true.
     */
    is_net_health_retrieval_enabled?: boolean;
    /**
     * True when document collection is enabled and the PAL MDR document generation screener setting is on for the submission's facility.
     */
    is_pcc_document_generation_enabled?: boolean;
    /**
     * external_emr_documents.id values the user marked for this submission. Selection is per submission, so two submissions for the same patient can attach different documents.
     */
    selected_emr_document_ids?: Array<string>;
    /**
     * Signed URL for the compiled concurrent review submission package. Present only once generation has finished, so its absence while the status is `review` means the package is still being built.
     */
    submission_package_s3_url?: string | null;
    /**
     * When the compiled submission package was last generated.
     */
    submission_package_generated_at?: Date | null;
    /**
     * True while the PointClickCare MDR document generation started by Build Case is still running. Step 1 waits on this as well as the Net Health pull, because both graphs feed the same package and neither waits on the other.
     */
    is_generating_mdr_documents?: boolean;
    /**
     * When the PointClickCare MDR document generation last finished. Set even when individual document types failed, so its presence means "no longer running" rather than "all documents exist".
     */
    mdr_documents_generated_at?: Date | null;
}



/**
 * Check if a given object implements the PalReauthSubmission interface.
 */
export function instanceOfPalReauthSubmission(value: object): value is PalReauthSubmission {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('pal_submission_id' in value) || value['pal_submission_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('timing_state' in value) || value['timing_state'] === undefined) return false;
    if (!('can_revert_status' in value) || value['can_revert_status'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    return true;
}

export function PalReauthSubmissionFromJSON(json: any): PalReauthSubmission {
    return PalReauthSubmissionFromJSONTyped(json, false);
}

export function PalReauthSubmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmission {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'pal_submission_id': json['pal_submission_id'],
        'status': PalReauthSubmissionStatusFromJSON(json['status']),
        'status_info': json['status_info'] == null ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['status_info']),
        'previous_status_info': json['previous_status_info'] == null ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['previous_status_info']),
        'external_id': json['external_id'] === undefined ? undefined : json['external_id'] === null ? null : json['external_id'],
        'next_review_date': json['next_review_date'] === undefined ? undefined : json['next_review_date'] === null ? null : json['next_review_date'],
        'timing_state': PalReauthSubmissionTimingStateFromJSON(json['timing_state']),
        'can_revert_status': json['can_revert_status'],
        'case_manager': json['case_manager'] == null ? undefined : PalReauthCaseManagerFromJSON(json['case_manager']),
        'status_updated_by_user': json['status_updated_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['status_updated_by_user']),
        'submitted_at': json['submitted_at'] === undefined ? undefined : json['submitted_at'] === null ? null : (parseDateTime(json['submitted_at'])),
        'submitted_by_user_id': json['submitted_by_user_id'] === undefined ? undefined : json['submitted_by_user_id'] === null ? null : json['submitted_by_user_id'],
        'submitted_by_user': json['submitted_by_user'] == null ? undefined : PalAuthSubmissionStatusUpdatedByUserFromJSON(json['submitted_by_user']),
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
        'submission_mode': json['submission_mode'] == null ? undefined : json['submission_mode'],
        'cycle_number': json['cycle_number'] == null ? undefined : json['cycle_number'],
        'is_document_collection_enabled': json['is_document_collection_enabled'] == null ? undefined : json['is_document_collection_enabled'],
        'is_net_health_retrieval_enabled': json['is_net_health_retrieval_enabled'] == null ? undefined : json['is_net_health_retrieval_enabled'],
        'is_pcc_document_generation_enabled': json['is_pcc_document_generation_enabled'] == null ? undefined : json['is_pcc_document_generation_enabled'],
        'selected_emr_document_ids': json['selected_emr_document_ids'] == null ? undefined : json['selected_emr_document_ids'],
        'submission_package_s3_url': json['submission_package_s3_url'] === undefined ? undefined : json['submission_package_s3_url'] === null ? null : json['submission_package_s3_url'],
        'submission_package_generated_at': json['submission_package_generated_at'] === undefined ? undefined : json['submission_package_generated_at'] === null ? null : (parseDateTime(json['submission_package_generated_at'])),
        'is_generating_mdr_documents': json['is_generating_mdr_documents'] == null ? undefined : json['is_generating_mdr_documents'],
        'mdr_documents_generated_at': json['mdr_documents_generated_at'] === undefined ? undefined : json['mdr_documents_generated_at'] === null ? null : (parseDateTime(json['mdr_documents_generated_at'])),
    };
}

export function PalReauthSubmissionToJSON(json: any): PalReauthSubmission {
    return PalReauthSubmissionToJSONTyped(json, false);
}

export function PalReauthSubmissionToJSONTyped(value?: PalReauthSubmission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'pal_submission_id': value['pal_submission_id'],
        'status': PalReauthSubmissionStatusToJSON(value['status']),
        'status_info': PalReauthSubmissionStatusInfoToJSON(value['status_info']),
        'previous_status_info': PalReauthSubmissionStatusInfoToJSON(value['previous_status_info']),
        'external_id': value['external_id'],
        'next_review_date': value['next_review_date'],
        'timing_state': PalReauthSubmissionTimingStateToJSON(value['timing_state']),
        'can_revert_status': value['can_revert_status'],
        'case_manager': PalReauthCaseManagerToJSON(value['case_manager']),
        'status_updated_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['status_updated_by_user']),
        'submitted_at': value['submitted_at'] == null ? value['submitted_at'] : serializeDateTime(value['submitted_at']),
        'submitted_by_user_id': value['submitted_by_user_id'],
        'submitted_by_user': PalAuthSubmissionStatusUpdatedByUserToJSON(value['submitted_by_user']),
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
        'submission_mode': value['submission_mode'],
        'cycle_number': value['cycle_number'],
        'is_document_collection_enabled': value['is_document_collection_enabled'],
        'is_net_health_retrieval_enabled': value['is_net_health_retrieval_enabled'],
        'is_pcc_document_generation_enabled': value['is_pcc_document_generation_enabled'],
        'selected_emr_document_ids': value['selected_emr_document_ids'],
        'submission_package_s3_url': value['submission_package_s3_url'],
        'submission_package_generated_at': value['submission_package_generated_at'] == null ? value['submission_package_generated_at'] : serializeDateTime(value['submission_package_generated_at']),
        'is_generating_mdr_documents': value['is_generating_mdr_documents'],
        'mdr_documents_generated_at': value['mdr_documents_generated_at'] == null ? value['mdr_documents_generated_at'] : serializeDateTime(value['mdr_documents_generated_at']),
    };
}

